import tunnel from 'tunnel-rat';

export const tunnels = {
  overlay: tunnel(),
  editor: tunnel(),
} as const;
